<template>
  <div
    class="fts-automation-node-for-each automation-node"
    :class="{
      'automation-node--debug': data.debug,
      'automation-node--debugging': isDebugging,
    }"
  >
    <div class="node-header">
      <div class="node-header__label">
        <i class="fts-icon-automation-for node-header-icon" />
        <div class="node-header-title">For</div>
      </div>
      <div class="node-header__action">
        <div class="node-debug-sequence" v-if="debugInformation">
          {{ debugInformation }}
        </div>
        <fts-automation-debugpoint
          v-model="data.debug"
          class="node-header__debugpoint"
          @input="updateData"
        />
      </div>
    </div>
    <div class="node-body">
      <div class="automation-node-for">
        <fts-formula
          v-model="data.list"
          :variables="priorVariables"
          class="automation-formula-form-control"
          @change="validateFormula"
          @input="updateData"
        />
      </div>

      <div class="automation-node-each">
        <div class="automation-node-each__label">each</div>
        <div class="automation-node-each__group">
          <i
            class="action-variable-icon"
            :class="informationIcon(data.variableType)"
          /> &nbsp;
          <div class="automation-node-each-content">
            <fts-automation-contenteditable
              v-model="data.item"
              @input="updateData"
            />
            <div
              class="automation-node-each-tag"
              v-if="data.moduleId || data.activityId || data.informationId"
            >
              <fts-automation-badge
                :moduleId="data.moduleId"
                :activity-id="data.activityId"
                :information-id="data.informationId"
                :isGroup="data.isGroup"
                class="automation-node-each-tag__badge"
              />
            </div>
          </div>
        </div>
      </div>

      <!-- <fts-automation-scoped-variables :variables="data.variables" style="margin-top: 1rem" /> -->
      <!-- <div>{{priorVariables}}</div> -->
    </div>
  </div>
</template>

<script>
import Vue from "vue";

import { automationDesignStore } from "../../store/automationDesignStore";
import commons from "../../commons/commons";
import FTSFormula from "../../design/FTSFormula.vue";
import FTSAutomationDebugpoint from "./FTSAutomationDebugpoint";
import FTSAutomationContenteditable from "./FTSAutomationContenteditable";
import FTSAutomationBadge from "./FTSAutomationBadge";
import FTSAutomationScopedVariables from "./FTSAutomationScopedVariables";

export default {
  props: {
    data: Object,
    information: Array,
  },
  data() {
    return {
      show: -1,
      content: "",
      formData: {},
      errorMessage: null,
      isDebugging: false,
      debugInformation: null,
      priorVariables: []
    };
  },
  computed: {
  },
  watch: {
    "data.item"(val) {
      if (val) {
        if (!this.data.itemFieldName) {
          this.data.itemFieldName = commons.generateFieldName();
        }

        automationDesignStore.dispatch("updateVariables");
      }
    },
  },
  components: {
    "fts-formula": FTSFormula,
    "fts-automation-debugpoint": FTSAutomationDebugpoint,
    "fts-automation-contenteditable": FTSAutomationContenteditable,
    "fts-automation-badge": FTSAutomationBadge,
    "fts-automation-scoped-variables": FTSAutomationScopedVariables,
  },
  methods: {
    informationIcon(id) {
      return commons.informationIcon(id) || "fts-icon-text";
    },
    updateData() {
      this.$forceUpdate();
    },
    async validateFormula() {
      let vm = this;
      vm.errorMessage = null;
      let diagram = lodash.cloneDeep(automationDesignStore.state.diagram);
      try {
        let result = await this.$store.dispatch("validateAutomation", {
          blocks: diagram,
          validate: {
            nodeId: this.data.id,
          },
        });

        if (!this.data.itemFieldName) {
          this.data.itemFieldName = commons.generateFieldName();
        }

        let returnedNode = Object.values(result.data.blocks).find(
          (x) => x.data.id == this.data.id
        );
        Vue.set(this.data, "variableType", returnedNode.data.variableType);

        if (returnedNode.data.moduleId)
          Vue.set(this.data, "moduleId", returnedNode.data.moduleId);
        else {
          Vue.set(this.data, "moduleId", null);
        }

        if (returnedNode.data.informationId)
          Vue.set(this.data, "informationId", returnedNode.data.informationId);
        else {
          Vue.set(this.data, "informationId", null);
        }

        if (returnedNode.data.isGroup)
          Vue.set(this.data, "isGroup", true);
        else {
          Vue.set(this.data, "isGroup", null);
        }

        automationDesignStore.dispatch("updateVariables");
        window.eventBus.$emit("refreshAutomationBlocks");
      } catch (err) {
        if (err.response && err.response.data && err.response.data.message) {
          vm.errorMessage = err.response.data.message;
        } else {
          vm.errorMessage = "Something went wrong";
        }
      }
    },
  },
  mounted() {
    let vm = this;

    window.eventBus.$on("refreshAutomationBlocks", () => {
      vm.isDebugging = false;
      if (
        automationDesignStore.state.debugPayload &&
        automationDesignStore.state.debugPayload.nodeId
      ) {
        let nodeId = automationDesignStore.state.debugPayload.nodeId;
        let diagram = automationDesignStore.state.diagram;
        let forEach = automationDesignStore.state.debugPayload.forEach;
        if (diagram[nodeId].data.id == vm.data.id) {
          vm.isDebugging = true;
        }

        let currentNode = Object.values(diagram).find(
          (x) => x.data.id == vm.data.id
        );
        var forEachLine = forEach.find((x) => x.nodeId == currentNode.id);
        if (forEachLine) {
          vm.debugInformation = `${forEachLine.index + 1} of ${
            forEachLine.count
          }`;
        } else {
          vm.debugInformation = "";
        }
      } else {
        vm.debugInformation = "";
      }

      try {
        vm.priorVariables = vm.data.variables.filter((x) => x.id !== vm.data.item);
      } catch (ex) {
        vm.priorVariables = [];
      }

      vm.$forceUpdate();
    });
  },
  beforeDestroy() {
    window.eventBus.$off("refreshAutomationBlocks");
  },
};
</script>

<style lang="scss">
@import "./src/assets/scss/vars.scss";

.fts-automation-node-for-each {
  .node-debug-sequence {
    @include flex-center-middle;
    height: 1.25rem;
    padding: 0 0.575rem;
    border-radius: 0.75rem;
    background: $dangerColor;
    color: #fff;
    font-size: 0.75rem;
  }
  .automation-node-for {
    margin-bottom: 0.575rem;
  }
  .automation-node-each {
    .automation-node-each__label {
      margin-bottom: 0.275rem;
      font-size: 0.875rem;
    }
    .automation-node-each__group {
      $each-group-font-size: 1rem;
      $each-group-icon-font-size: 0.875rem;
      display: flex;
      align-items: flex-start;
      font-size: $each-group-font-size;
      .automation-node-each-icon {
        margin-top: calc(#{$each-group-font-size - $each-group-icon-font-size});
        margin-right: 0.375rem;
        font-size: $each-group-icon-font-size;
      }
      .automation-node-each-content {
        min-width: 0;
        /* override */
        .automation-contenteditable-action {
          color: #eee;
        }
      }
      .automation-node-each-tag {
        max-width: 100%;
        display: inline-block;
        margin-top: 0.175rem;
        padding: 0.175rem 0.575rem;
        border-radius: 0.5rem;
        background: #eee;
        color: #000;
        .automation-node-each-tag__badge {
          font-size: 0.675rem;
        }
      }
    }
  }
}
</style>